import { useTranslation } from 'react-i18next';
import { LogIn, Clock, MonitorSmartphone } from 'lucide-react';

interface SessionExpiredDialogProps {
  onLogin: () => void;
  /** Grund aus dem 401 (z. B. 'session_superseded' = auf anderem Gerät angemeldet). */
  reason?: string;
}

export function SessionExpiredDialog({ onLogin, reason }: SessionExpiredDialogProps) {
  const { t } = useTranslation();
  const superseded = reason === 'session_superseded';
  const title = superseded
    ? t('auth.sessionSuperseded', 'Sitzung beendet')
    : t('auth.sessionExpired', 'Sitzung abgelaufen');
  const message = superseded
    ? t('auth.sessionSupersededMessage', 'Nicht genügend Benutzerlizenzen: Ihre Sitzung wurde beendet, weil das Konto auf einem anderen Gerät angemeldet wurde. Pro Lizenz ist eine aktive Anmeldung möglich – für weitere Geräte wird eine zusätzliche Lizenz benötigt.')
    : t('auth.sessionExpiredMessage', 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.');

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-8 max-w-sm w-full mx-4 animate-in fade-in zoom-in duration-200">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-4">
            {superseded
              ? <MonitorSmartphone className="w-8 h-8 text-amber-600 dark:text-amber-400" />
              : <Clock className="w-8 h-8 text-amber-600 dark:text-amber-400" />}
          </div>

          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            {title}
          </h2>

          <p className="text-gray-500 dark:text-gray-400 mb-6">
            {message}
          </p>

          <button
            onClick={onLogin}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            <LogIn className="w-5 h-5" />
            {t('auth.loginAgain', 'Wieder einloggen')}
          </button>
        </div>
      </div>
    </div>
  );
}
